export default __webpack_public_path__ + "static/media/element_spec_3.4d910252.webp";